var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.$style.container }, [
    _c("div", { class: _vm.$style.titleWrapper }, [
      _vm.titleIconName
        ? _c(
            "div",
            { class: _vm.$style.icon },
            [_c("NsIcon", { attrs: { "icon-name": _vm.titleIconName } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("span", { class: _vm.$style.title }, [_vm._v(_vm._s(_vm.title))])
    ]),
    _vm._v(" "),
    _c("div", { class: _vm.$style.subtitle }, [_vm._v(_vm._s(_vm.subtitle))])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }